import axios from 'axios'

export const getAllReceipt = (params) => {
  return axios.get('/receipts', {params: params})
}

export const getReceipt = (id, params) => {
  return axios.get('/receipts/' + id, {params: params})
}

export const createReceipt = (data) => {
  return axios.post('/receipts', data)
}

export const editReceipt = (id, data) => {
  return axios.put('/receipts/' + id, data)
}

export const deleteReceipt = (id) => {
  return axios.delete('/receipts/' + id)
}

export const confirmReceipt = (id) => {
  return axios.put('receipts/' + id + '/confirm')
}



// WEBPACK FOOTER //
// ./src/api/receipt.js